import { render, staticRenderFns } from "./KPICard.vue?vue&type=template&id=73aad063"
import script from "./KPICard.vue?vue&type=script&lang=js"
export * from "./KPICard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports